import { LcsMultiSelectTextContentFn, LcsMultiSelectTriggerComponent } from '@lcs/shared/multi-select';

export function entityMultiSelectText<T = any>(
   multiSelect: LcsMultiSelectTriggerComponent<T>,
   singularName: string,
   pluralName: string = singularName + 's'
): LcsMultiSelectTextContentFn<T> {
   return (items: readonly T[] | null | undefined, allCheckboxChecked: boolean): string => {
      if (allCheckboxChecked) {
         return 'All';
      }
      if (!items || items.length === 0) {
         return '';
      }
      if (items.length === 1) {
         const displayWith = multiSelect.panel.displayWith;
         const displayValue = displayWith ? displayWith(items[0]) : null;
         return displayValue ?? `1 ${singularName}`;
      }
      return `${items.length} ${pluralName}`;
   };
}
